import axios from "axios";
import { useCallback } from "react";

import { makeToast } from "@/components/Toast/Toast";

export interface IUseDownload {
  fileUrl: string;
  originalName?: string;
}

export function useDownload(): ({
  fileUrl,
  originalName,
}: IUseDownload) => Promise<void> {
  const downloadFile = useCallback(
    async ({ fileUrl, originalName = "File" }: IUseDownload) => {
      try {
        // Strip Cloudinary auto-formatting transformations which corrupt PDF downloads
        const cleanUrl = fileUrl.replace(/\/f_auto[^/]*\//g, "/");

        const response = await axios.get(cleanUrl, {
          responseType: "blob", // Important to process the file correctly
        });

        // Create a URL for the blob
        const objectURL = window.URL.createObjectURL(new Blob([response.data]));
        const anchor = document.createElement("a");
        document.body.appendChild(anchor);
        anchor.style.display = "none";
        anchor.href = objectURL;
        anchor.download = originalName;
        anchor.click();

        // Clean up by revoking the blob URL and removing the anchor element
        window.URL.revokeObjectURL(objectURL);
        document.body.removeChild(anchor);
      } catch (error) {
        makeToast({ intent: "danger", title: "Download failed." });
      }
    },
    []
  );

  return downloadFile;
}
